import { render, staticRenderFns } from "./commissioned-dialog.vue?vue&type=template&id=28b68b1a&scoped=true"
import script from "./commissioned-dialog.vue?vue&type=script&lang=ts"
export * from "./commissioned-dialog.vue?vue&type=script&lang=ts"
import style0 from "./commissioned-dialog.vue?vue&type=style&index=0&id=28b68b1a&prod&lang=less&scoped=true"
import style1 from "./commissioned-dialog.vue?vue&type=style&index=1&id=28b68b1a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b68b1a",
  null
  
)

export default component.exports